export const translations = {
  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      technology: "Technology",
      services: "Services",
      projects: "Projects",
      trackRecord: "Global Footprint",
      contact: "Contact"
    },
    // Hero Section
    hero: {
      headline: "Zero Dry Wells. Precision Oil Exploration.",
      subheadline: "Using the Geophysical Reservoir Sensor (GRS) — combining radar sensing with thermal, gravitational, electrostatic, and ionic-field analysis — to reduce exploration risk and massive capital cost.",
      trustBadge: "Recommended by the Council of Ministers of Belarus",
      primaryCta: "Explore Our Technology",
      secondaryCta: "Download Full Profile"
    },
    // Promise Section
    promise: {
      title: "PETROSERVICE Guarantee",
      accuracy: {
        title: "Unmatched Accuracy",
        desc: "90% Success rate in predicting positive commercial accumulation."
      },
      efficiency: {
        title: "Extreme Efficiency",
        desc: "Eliminates costly exploratory drilling in dry accumulations."
      },
      mobility: {
        title: "Onshore & Offshore",
        desc: "Operational both onshore and offshore with portable and marine-capable equipment."
      }
    },
    // Challenge Section
    challenge: {
      problemTitle: "THE PROBLEM",
      problemDesc: "Traditional methods (like seismic) only identify structural traps. They do not confirm the presence of oil, leading to wells that cost $4M-$100M but may yield nothing.",
      solutionTitle: "OUR SOLUTION",
      solutionDesc: "We directly detect commercial hydrocarbon accumulations using our comprehensive technologies, ensuring your investment goes into a productive well.",
      solutionMetric: "90% Positive Commercial Accumulations Detection"
      ,
      riskAmount: "$4M-$100M",
      riskNote: "per well\nat risk"
    },
    // Global Footprint
    footprint: {
      title: "Our Global Footprint",
      desc: "Petroservice is a Belarusian company, established in 2014, operating internationally in key markets including: Belarus, Kazakhstan, Russia, and the Syrian Arab Republic.",
      stat1: "9+ Years Active",
      stat2: "+25 Successful Project",
      stat3: "Millions Saved",
      countries: ["Belarus","Kazakhstan","Russia","Syria"]
    },
    // CTA Section
    cta: {
      title: "Unlock Substantial Cost Savings in Petroleum Exploration",
      button: "Contact Our Team"
    },
    // Technology Page
    technology: {
      pageTitle: "The GRS Method: Direct Detection of Hydrocarbons",
      belarusShort: "Официальная рекомендация Администрации Совета Министров",
      intro: "The GRS (Geophysical Reservoir Sensor) is the new standard in direct detection. The GRS combines radar sensing with thermal radiation, gravitational, electrostatic, and ionic-field analysis to detect and explore subsurface reservoirs of water, oil, and gas, rather than relying solely on geological structure.",
      methodTitle: "The Method of Work",
      implementationTitle: "The Implementation Method",
      processTitle: "The Process",
      step1Title: "Signal Injection",
      step1Desc: "A proprietary transmitter injects a precise, multi-frequency electromagnetic field into the target area.",
      step1NewTitle: "Detection of Ionic Fields:",
      step1NewDesc: "The GRS device receive electromagnetic or electrostatic signals from the ground, which interact with these ionic fields. When these signals encounter areas with strong ionic activity, such as fluid reservoirs, they experience changes in frequency, phase, or amplitude",
      step2Title: "Anomalous Interaction",
      step2Desc: "If an oil/gas accumulation is present, it generates a unique secondary electromagnetic field (the anomaly) that travels back to the surface.",
      step2NewTitle: "Electrostatic Sensing:",
      step2NewDesc: "The device is equipped with sensors designed to detect electrostatic variations in the subsurface environment. These sensors pick up the changes in the electric field caused by the presence of ionic activity in the underground reservoirs, differences in the ionic field strength help indicate the presence and type of fluid (e.g., oil, gas, or water)",
      step3Title: "Data Collection",
      step3Desc: "Our 3rd Generation RWRC-3 receiver (3000mm antenna) collects the returning data, which is analyzed to definitively map the reservoir boundary and content.",
      step3NewTitle: "Signal Processing and Interpretation:",
      step3NewDesc: "Once the GRS capture the signals altered by the ionic field, the data is processed through its internal systems. Advanced algorithms analyze the variations in electrostatic charge and identify areas where the ionic field is strong, suggesting the presence of resources. This processed data is used to determine the location, depth, and boundaries of potential oil, gas, or water reservoirs.",
      step4Title: "Resource Mapping",
      step4Desc: "Data is converted into 2D/3D visualizations, including maps showing ionic field concentration. These maps accurately pinpoint areas and determine the depth, which reaches up to 6,000 meters underground.",
      step4NewTitle: "Mapping and Visualization:",
      step4NewDesc: "After interpreting the ionic field data, the GRS creates a visual representation, such as maps, showing where the ionic field is concentrated. These maps guide exploration efforts by pinpointing areas likely to contain hydrocarbons or groundwater. By utilizing ionic field detection, the GRS device enhance its ability to accurately locate underground resources",
      specsTitle: "Mobility & Specifications",
      spec1Title: "Advanced Electrostatic System (Ionic Field Analysis)",
      spec1Desc: "This system is used to determine the nature of fluids present in porous rocks by detecting changes in the electrostatic and ionic fields of the subsurface, helping to identify the contact boundaries (WOC or OWC).",
      spec2Title: "Thermal Radiation Analysis",
      spec2Desc: "Utilizes thermal property differences between hydrocarbons and surrounding rock. By analyzing heat flow variations, this method effectively distinguishes between potential gas and oil traps.",
      spec3Title: "Gravitational Variation System",
      spec3Desc: "by using gravitional system analysis and measure the gravity anomalies in order to estimate the depth and dimensions of geological layers that host oil and gas gravity",
      comparisonTitle: "The Difference",
      tableFeature: "Feature",
      tableSeismic: "Traditional Seismic",
      tableEmaf: "Petroservice GRS",
      rowDetects: "Detects",
      rowDetectsSeismic: "Geological Traps (Structure)",
      rowDetectsEmaf: "Hydrocarbon Content (Oil/Gas)",
      rowRisk: "Risk",
      rowRiskSeismic: "High (Requires costly drilling to validate)",
      rowRiskEmaf: "90% Sufficient warranty of positive commercial Hydrocarbon accumulations. Low risk (validates content before drilling).",
      rowAccess: "Access",
      rowAccessSeismic: "Heavy machinery dependent",
      rowAccessEmaf: "All-terrain, portable equipment"
    },
    // Services Page
    services: {
      pageTitle: "Comprehensive Solutions for Risk Reduction and Discovery",
      service1Title: "Pre-Drilling Validation",
      service1Objective: "Objective: Eliminate drilling in dry structures.",
      service1Desc: "We survey prospects identified by seismic to definitively confirm the presence (or absence) of hydrocarbons before rig mobilization.",
      service1BenefitTitle: "Benefit: ",
      service1BenefitDesc: "Maximizes capital efficiency and reduces technical and operational risks with a 100% Warranty against the dry traps.",
      service2Title: "Exploration Survey",
      service2Objective: "Objective: Direct detection of the sub-surface traps carrying petroleum and delineation of their boundaries.",
      service2Desc: "We explore large, unknown areas using the GRS to quickly and inexpensively identify new potential reservoir locations.",
      service2BenefitTitle: "Benefit: ",
      service2BenefitDesc: "Rapidly identifies high potential areas, reducing the time and cost of subsequent seismic campaigns, and offering a 90% Sufficient warranty of positive commercial Hydrocarbon accumulations onshore and offshore.",
      service3Title: "Geological Support",
      service3Desc: "Our data, generated by the GRS (Geophysical Reservoir Sensor), integrates seamlessly with existing geological models and seismic data. It provides a critical layer of confidence by confirming whether an identified trap is oil-bearing or barren, with exploration depth reaching up to 6,000 meters.",
      service4Title: "Specialised Environments",
      service4Urban: "Urban & Complex Terrain: Our unique, portable equipment allows us to survey complex, restricted environments, including mining/industrial sites, crowded urban centers, and remote mountainous or forested regions with low access risk.",
      service4Marine: "Marine Surveys: We are successfully conducting survey experiments in marine and offshore areas, bringing the same cost-saving accuracy to water-based exploration.",
      service4Combined: "Our unique portable equipment allows us to survey complex, restricted environments including marine areas, mountainous regions, and remote critical zones."
    },
    // Projects Page
    projects: {
      pageTitle: "Our Projects & Case Studies",
      pageSubtitle: "Discover how Petroservice has helped clients across multiple countries reduce exploration risk and discover productive oil reservoirs.",
      completed: "Completed",
      ongoing: "Ongoing",
      statSurveys: "Surveys Completed",
      statCountries: "Countries",
      statAccuracy: "Accuracy Rate",
      statSaved: "Client Savings",
      belarus: "Belarus Operations",
      belarusDesc: "Our home country operations where we developed and refined the GRS technology. Multiple successful surveys across various geological formations.",
      belarusResult1: "Discovered multiple new oil reservoirs",
      belarusResult2: "Prevented drilling in 12+ identified dry traps",
      belarusResult3: "Official endorsement from Council of Ministers",
      belarusHighlight: "Key Achievement: Government recommendation for all national exploratory works",
      kazakhstan: "Kazakhstan Exploration",
      kazakhstanDesc: "Large-scale exploration projects in the oil-rich regions of Kazakhstan, working with national and international oil companies.",
      kazakhstanResult1: "Surveyed over 500 km² of exploration area",
      kazakhstanResult2: "Identified 8 new prospective reservoir zones",
      kazakhstanResult3: "Saved estimated $15M in avoided dry drilling",
      kazakhstanHighlight: "Key Achievement: 100% accuracy in dry-trap detection across all surveyed areas",
      russia: "Russia ",
      russiaDesc: "Ongoing operations in two major Russian oil regions, providing pre-drilling validation and new reservoir discovery services.",
      russiaResult1: "Active surveys in Krasnodar and Samara regions",
      russiaResult2: "Multiple reservoirs now under active investment",
      russiaResult3: "Integrated with existing seismic programs",
      russiaHighlight: "Key Achievement: Several discoveries now in production phase",
      syria: "Syrian Arab Republic",
      syriaDesc: "Officially qualified operations in Syria, contributing to the development and renaissance of the Middle Eastern petroleum industry.",
      syriaResult1: "Qualified by Ministry of Oil (Resolution No. 6135)",
      syriaResult2: "Supporting national oil exploration programs",
      syriaResult3: "Focus on post-conflict resource development",
      syriaHighlight: "Key Achievement: First GRS technology deployment in the Middle East",
      marineTitle: "Marine & Offshore Expansion",
      marineDesc: "We are successfully conducting survey experiments in marine and offshore areas, extending our proven land-based accuracy to water-based exploration environments.",
      marineStatus: "Currently in experimental phase",
      ctaTitle: "Start Your Project With Us",
      ctaDesc: "Join our growing list of successful projects across the globe."
    },
    // Track Record Page
    trackRecord: {
      pageTitle: "Proven Results. Government Trust. Global Reach.",
      caseStudiesTitle: "Case Studies",
      caseStudyKrasnodarTitle: "Marine Environment Success",
      caseStudyKrasnodarBody: "Successfully tested in the Kurchansky Liman water area. Results confirmed that water layer thickness does not affect instrumentation readings.",
      caseStudySamaraTitle: "Dry vs. Oil-Bearing Differentiation",
      caseStudySamaraBody: "Accurately distinguished between the oil-bearing 'Gorky' structure and the dry 'Yaltau' structure. Subsequent drilling confirmed the 'Yaltau' site was dry, validating the prediction.",
      caseStudyKazakhstanTitle: "Complex Reservoir Mapping",
      caseStudyKazakhstanBody: "Achieved high convergence with gas condensate accumulation contours at the Chinarev field, despite complex multi-strata geology.",
      clientHistoryTitle: "Client History",
      clientBelorusneft: "Belorusneft (Belarus)",
      clientRusOil: "Rus-Oil (Russia)",
      clientRITEK: "RITEK (Russia)",
      clientSyrianPC: "Syrian Petroleum Company (Syria)",
      clientOther: "Other Clients:",
      clientOtherList: "Pechoraneftegaz, Zhaikmunai, Adai Petroleum, Lukoil-Kaliningradmorneft, Rosneft-Krasnodarneftegaz, Samaraneftegaz.",
      projectYears: "Years",
      projectCount: "Projects",
      endorsementLabel: "Government Endorsement",
      repBelarus: "Republic of Belarus",
      internationalQualificationLabel: "International Qualification",
      successRateLabel: "Success Rate",
      dryTrapDetectionLabel: "Dry-Trap Detection",
      belarusTitle: "Official Recommendation from the Presidency of the Council of Ministers of Belarus",
      belarusDesc: "Following the great success of the GRS method in determining oil accumulations and dry structures, the Presidency of the Council of Ministers of the Republic of Belarus officially directed the use of Petroservice’s method in all exploratory works within its territory and advised its expansion beyond the borders.",
      belarusShort: "Council of Ministers Official Recommendation",
      accuracyTitle: "100% Success Rate in Dry-Trap Detection",
      accuracyDesc: "Petroservice statistics show a 100% success rate in expecting dry traps. When results indicate an absence of electromagnetic anomalies, it signifies a dry trap. This has saved vast resources, estimated at tens of millions of dollars, by preventing expenditure on unsuccessful exploratory wells (e.g., up to $7M per onshore well).",
      syriaTitle: "Qualified to Operate in the Middle East",
      syriaDesc: "We have been officially qualified by the Syrian Ministry of Energy to operate within the territory of the Syrian Arab Republic.",
      syriaBadge: "Qualified by the Syrian Ministry of Energy — Resolution No. 6135",
      syriaQualificationDate: "December 4, 2019",
      successRatePercent: "100%",
      refineryImageAlt: "Belarus operations",
      drillingImageAlt: "Middle East operations",
      visionmainTitle: "Our Vision and Mission",
      visionTitle: "Vision",
      missionTitle: "Mission",
      objectiveTitle: "Objective",
      vision: "The vital contribution to economic development through the sufficient utilization of local treasuries globally.",
      mission: "The renaissance of the oil industry capacities.",
      objective: "Enable territories to focus on the best investment in oil and gas by providing high-accuracy, low-cost know-how with a sufficient warranty."
    },
    about: {
      pageTitle: "About Petroservice",
      intro: "A Belarusian petroleum services company established in 2014. We provide direct-detection exploration technologies that reduce exploration risk, time and cost across international onshore and offshore projects.",

      overviewTitle: "Company Overview",
      overviewText: "Founded in 2014, Petroservice develops and deploys the GRS (Geophysical Reservoir Sensor) for direct detection of hydrocarbon accumulations. Our work in Belarus, Russia, Kazakhstan, Syria and other regions has validated the method and delivered measurable cost savings by avoiding dry-drilling.",

      partnerTitle: "Partner in Success",
      partnerText: "KH Group acts as our strategic partner and local representative, enabling project delivery, regional coordination and long-term client relationships.",

      whyTitle: "Why Petroservice",
      whyPoint1: "Direct detection of hydrocarbon-bearing traps — not just structural mapping.",
      whyPoint2: "High accuracy that reduces exploratory risk and prevents dry wells.",
      whyPoint3: "Faster surveys and lower operational costs compared with many traditional methods.",
      whyPoint4: "Applicable both onshore and offshore with portable and marine-capable equipment.",
      whyPoint5: "Proven results and formal endorsement from national authorities.",

      goalsTitle: "Company Goals",
      goalsPoint1: "Direct detection and delineation of subsurface traps.",
      goalsPoint2: "Avoid unnecessary exploratory drilling and preserve national resources.",
      goalsPoint3: "Support national economies by saving funds and redirecting investment to productive projects.",
      goalsPoint4: "Minimize exploratory risk and increase success rates for wildcat and follow-on wells.",

      methodsTitle: "Our Methodology",
      methodsIntro: "Petroservice uses a combined sensor approach (electrostatic, thermal and gravity) integrated in the GRS to identify and validate hydrocarbon accumulations.",
      methodElectrostaticTitle: "Electrostatic Sensing",
      methodElectrostaticDesc: "Detects ionic and electrostatic variations to distinguish water from hydrocarbons and identify WOC/OWC contact boundaries.",
      methodThermalTitle: "Thermal / Radiation Analysis",
      methodThermalDesc: "Analyzes thermal signatures to help differentiate oil from gas and detect accumulations via heat-flow anomalies.",
      methodGravityTitle: "Gravitational Analysis",
      methodGravityDesc: "Measures gravity anomalies to reveal subsurface structure and estimate depth and dimensions of reservoir-bearing layers.",

      implementationTitle: "Implementation & GRS",
      implementationIntro: "The GRS receives electromagnetic signals, processes them with advanced algorithms and converts results into maps and depth models for field planning.",
      implementationStep1: "Detection of Ionic Fields: signals interacting with ionic fields change in frequency, phase or amplitude.",
      implementationStep2: "Electrostatic Sensing: sensors pick up electric-field variations to indicate fluid type (oil, gas, water).",
      implementationStep3: "Signal Processing: processed data identifies likely resource areas and estimates depth and boundaries.",
      implementationStep4: "Mapping: visual maps and depth models guide exploration and drilling decisions (up to 6,000m depth).",

      achievementsTitle: "Company Achievements",
      achievementsText: "Since 2014 we have completed dozens of surveys contributing to new reservoir discoveries and preventing drilling in many dry traps — saving clients tens of millions of dollars in aggregate.",

      endorsementTitle: "Official Recognition",
      endorsementText: "The method has gained high-level recognition and formal recommendation from national authorities in Belarus following successful deployments.",

      contactTitle: "Regional Offices & Contact",
      contactIntro: "We operate internationally; reach our regional teams for project inquiries and partnerships.",
      contactBelarus: "220073, Republic of Belarus, Minsk, Olshevskogo st., bldg. 24, room 7a, office 7a-1-101.",
      contactBelarusPhone: "+375 44 7444444 / +375 44 4444447 / +375 29 3192377",
      contactBelarusEmail: "info@petroservice.by",
      contactKHTitle: "Representative — KH Group",
      contactKHText: "Damascus (Syria) and Dubai (UAE) offices — local coordination and client liaison.",

      callToAction: "Join us to reduce exploration risk and unlock productive investments."
    },
    // Contact Page
    contact: {
      pageTitle: "Start Your Risk-Free Exploration",
      formName: "Name",
      formCompany: "Company",
      formEmail: "Email",
      formCountry: "Country of Operation",
      formInquiry: "Inquiry Type",
      formMessage: "Message",
      formSubmit: "Send Inquiry",
      inquiryTypes: {
        consultation: "Technical Consultation",
        partnership: "Partnership",
        general: "General Inquiry"
      },
      hqTitle: "Headquarters",
      hqLocation: "Petroservice HQ (Belarus)",
      hqAddress: "220073, Republic of Belarus, Minsk, Olshevskogo st., bldg. 24, room 7a, office 7a-1-101.",
      hqPhone: "+375 44 7444444 / +375 44 4444447 / +375 29 3192377",
      hqEmail: "info@petroservice.by",
      dubaiOfficeTitle: "Middle East Office (Dubai - UAE)",
      dubaiOfficeAddress: "Dubai - UAE",
      dubaiOfficePhone: "+971 55 106 6128",
      repOfficeTitle: "Representative Office (KH Group)",
      repOfficeAddress: "Damascus, Syria",
      repOfficePhone: "+963 965 350 010 / +963 965 350 066",
      repOfficeEmail: "info@Kh.sy / info@petro.kh-co.com",
      repOfficeWebsite: "www.kh.sy",
      downloads: "Downloads",
      downloadProfile: "Download Full Petroservice Company Profile (PDF)",
      downloadEmafTechnicalPaper: "Download GRS Technical Paper (PDF)",
      downloadTechnical: "Download GRS Technical Paper",
      successMessage: "Thank you! Your inquiry has been submitted successfully.",
      errorMessage: "Something went wrong. Please try again.",
      selectInquiryPlaceholder: "Select inquiry type",
      submitting: "Submitting..."
    },
    // Footer
    footer: {
      copyright: "© 2025 Petroservice. All Rights Reserved.",
      privacy: "Privacy Policy",
      terms: "Terms of Service",
      companyIntro: "Pioneering direct hydrocarbon detection technology since 2014.",
      quickLinksLabel: "Quick Links",
      logoAlt: "Petroservice"
    }
    ,
    kh: {
      title: "KH Group: Strategic Partner",
      line1: "KH Group is the strategic partner and executive representative of PETRO SERVICE.",
      line2: "A mutual success story since 2014 — built on trust, technical expertise, and a shared commitment to delivering measurable results."
    }
  },
  ru: {
    nav: {
      home: "Главная",
      about: "О нас",
      technology: "Технологии",
      services: "Услуги",
      projects: "Проекты",
      trackRecord: "География работы",
      contact: "Контакты"
    },
    hero: {
      headline: "Ни одной  пустой скважины. Точная разведка нефти.",
      subheadline: "Использование GRS (Геофизического датчика резервуара) — сочетание радиолокационного зондирования с анализом теплового излучения, гравитационных, электростатических и ионных полей — для снижения рисков разведки и значительных капитальных затрат.",
      trustBadge: "Рекомендовано Советом Министров Республики Беларусь",
      primaryCta: "Узнайте о нашей технологии",
      secondaryCta: "Скачать профиль компании"
    },
    promise: {
      title: "Гарантия PETROSERVICE",
      accuracy: {
        title: "Непревзойдённая точность",
        desc: "90% успеха в прогнозировании перспективных коммерческих залежей."
      },
      efficiency: {
        title: "Максимальная эффективность",
        desc: "Исключает дорогостоящее разведочное бурение в сухих залежах."
      },
      mobility: {
        title: "На суше и на море",
        desc: "Работаем как на суше, так и на шельфе с портативным и морским оборудованием."
      }
    },
    challenge: {
      problemTitle: "ЕСТЬ ПРОБЛЕМА",
      problemDesc: "Традиционные методы (например, сейсморазведка) выявляют лишь структурные ловушки. Они не подтверждают наличие нефти, что ведёт к бурению скважин стоимостью от $4 до $100 млн, которые могут оказаться пустыми.",
      solutionTitle: "НАШЕ РЕШЕНИЕ",
      solutionDesc: "Мы напрямую обнаруживаем промышленные скопления углеводородов с помощью нашего комплекса технологий, гарантируя, что ваши инвестиции пойдут в работающую скважину.",
      solutionMetric: "90% Точность обнаружения коммерческих залежей"
      ,
      riskAmount: "$4–100 млн",
      riskNote: "риска на\nкаждую скважину"
    },
    footprint: {
      title: "Наше присутствие в мире",
      desc: "Petroservice — белорусская компания, основанная в 2014 году, работающая на международном рынке, включая такие ключевые страны, как: Беларусь, Казахстан, Россия и Сирийская Арабская Республика.",
      stat1: "Более 9 лет На рынке",
      stat2: "+25 Реализовано проектов",
      stat3: "Сэкономлено средств"
      ,
      countries: ["Беларусь","Казахстан","Россия","Сирия"]
    },
    cta: {
      title: "Раскройте потенциал значительной экономии средств в нефтеразведке",
      button: "Связаться с командой"
    },
    technology: {
      pageTitle: "Метод GRS: Прямое обнаружение углеводородов",
      intro: "GRS (Геофизический датчик резервуара) — новый стандарт в прямой разведке. GRS сочетает радиолокационное зондирование с анализом теплового излучения, гравитационных, электростатических и ионных полей для обнаружения и исследования подповерхностных резервуаров воды, нефти и газа, а не полагается исключительно на геологическую структуру.",
      methodTitle: "Метод работы",
      implementationTitle: "Метод внедрения",
      processTitle: "Процесс",
      step1Title: "Инъекция сигнала",
      step1Desc: "Фирменный передатчик вводит точное многочастотное электромагнитное поле в целевую область.",
      step1NewTitle: "Обнаружение ионных полей:",
      step1NewDesc: "Устройство GRS принимает электромагнитные или электростатические сигналы от земли, которые взаимодействуют с этими ионными полями. Когда эти сигналы сталкиваются с областями с высокой ионной активностью, такими как резервуары с жидкостью, они испытывают изменения частоты, фазы или амплитуды.",
      step2Title: "Аномальное взаимодействие",
      step2Desc: "При наличии скопления нефти/газа оно генерирует уникальное вторичное электромагнитное поле (аномалию), которое возвращается на поверхность.",
      step2NewTitle: "Электростатическое зондирование:",
      step2NewDesc: "Устройство оснащено датчиками, предназначенными для обнаружения электростатических вариаций в подповерхностной среде. Эти датчики улавливают изменения электрического поля, вызванные присутствием ионной активности в подземных резервуарах; различия в напряженности ионного поля помогают определить наличие и тип жидкости (например, нефти, газа или воды).",
      step3Title: "Сбор данных",
      step3Desc: "Наш приемник RWRC-3 третьего поколения (антенна 3000 мм) собирает возвращающиеся данные для точного картирования границ и содержимого резервуара.",
      step3NewTitle: "Обработка и интерпретация сигналов:",
      step3NewDesc: "После того как GRS улавливает сигналы, измененные ионным полем, данные обрабатываются его внутренними системами. Усовершенствованные алгоритмы анализируют вариации электростатического заряда и идентифицируют области с сильным ионным полем, что указывает на наличие ресурсов. Эти обработанные данные используются для определения местоположения, глубины и границ потенциальных резервуаров нефти, газа или воды.",
      step4Title: "Картирование ресурсов",
      step4Desc: "Данные преобразуются в 2D/3D визуализации, включая карты, показывающие концентрацию ионного поля. Эти карты точно определяют районы и определяют глубину, которая достигает до 8000 метров под землей.",
      step4NewTitle: "Картирование и визуализация:",
      step4NewDesc: "После интерпретации данных ионного поля GRS создает визуальное представление, такое как карты, показывающие концентрацию ионного поля. Эти карты направляют разведочные работы, точно указывая области, которые, вероятно, содержат углеводороды или грунтовые воды. Используя обнаружение ионного поля, устройство GRS повышает свою способность точно определять местонахождение подземных ресурсов.",
      specsTitle: "Мобильность и характеристики",
      spec1Title: "Усовершенствованная электростатическая система (анализ ионного поля)",
      spec1Desc: "Эта система используется для определения характера флюидов в пористых породах путём обнаружения изменений в электростатическом и ионном полях подземного пространства, что помогает выявить контактные границы (водонефтяной или газоводяной контакт — WOC или OWC).",
      spec2Title: "Анализ теплового излучения",
      spec2Desc: "Анализирует разницу тепловых свойств углеводородов и окружающих пород. Изучая вариации теплового потока, этот метод эффективно различает потенциальные газовые и нефтяные ловушки.",
      spec3Title: "Гравитационно-вариационная система",
      spec3Desc: "Использует анализ гравитационного поля и измерение гравитационных аномалий для оценки глубины и размеров геологических пластов, содержащих нефть и газ.",
      comparisonTitle: "Различия",
      tableFeature: "Параметр",
      tableSeismic: "Традиционная сейсморазведка",
      tableEmaf: "Технология GRS от Petroservice",
      rowDetects: "Выявляет",
      rowDetectsSeismic: "Геологические ловушки (структуру)",
      rowDetectsEmaf: "Наличие углеводородов (нефть/газ)",
      rowRisk: "Риск",
      rowRiskSeismic: "Высокий (требует дорогостоящего бурения для подтверждения)",
      rowRiskEmaf: "Низкий. Гарантия успешного обнаружения промышленных  залежей — 90%. Позволяет подтвердить наличие ресурсов до бурения.",
      rowAccess: "Доступность",
      rowAccessSeismic: "Зависит от тяжелой техники",
      rowAccessEmaf: "Вездеходное, портативное оборудование"
    },
    services: {
      pageTitle: "Комплексные решения для снижения рисков и открытия месторождений",
      service1Title: "Предварительная проверка перед бурением",
      service1Objective: "Цель: исключить бурение в непродуктивных (сухих) структурах.",
      service1Desc: "Мы проводим обследование перспективных объектов, выявленных сейсморазведкой, чтобы достоверно подтвердить наличие (или отсутствие) углеводородов до начала мобилизации буровой установки.",
      service1BenefitTitle: "Выгода: ",
      service1BenefitDesc: "Максимизирует эффективность капитала и снижает технические и эксплуатационные риски со 100% гарантией от сухих ловушек.",
      service2Title: "Разведочное обследование",
      service2Objective: "Цель: прямое обнаружение подземных ловушек, содержащих углеводороды, и определение их границ.",
      service2Desc: "Мы исследуем обширные малоизученные территории с помощью GRS, чтобы быстро и с минимальными затратами выявить новые потенциальные локации залежей.",
      service2BenefitTitle: "Преимущество: ",
      service2BenefitDesc: "Быстрое определение высокоперспективных зон, что сокращает время и стоимость последующих сейсмических кампаний. Предоставляется 90% достаточная гарантия обнаружения промышленных скоплений углеводородов на суше и на шельфе.",
      service3Title: "Геологическое сопровождение",
      service3Desc: "Наши данные, полученные с помощью GRS (Геофизического Датчика Пласта), легко интегрируются с существующими геологическими моделями и данными сейсморазведки. Они предоставляют критически важный уровень уверенности, подтверждая, является ли выявленная ловушка нефтеносной или пустой. Глубина исследований достигает 8000 метров.",
      service4Title: "Работа в специализированных условиях",
      service4Urban: "Городские и сложные ландшафты: Наше уникальное портативное оборудование позволяет проводить исследования в сложных, труднодоступных условиях, включая горнодобывающие/промышленные объекты, густонаселенные городские центры, а также удаленные горные или лесистые районы с минимальными рисками доступа.",
      service4Marine: "Морские исследования: Мы успешно проводим опытно-методические работы в морских и шельфовых зонах, обеспечивая такую же точность и экономическую эффективность для разведки на акваториях.",
      service4Combined: "Наше уникальное портативное оборудование позволяет обследовать сложные, ограниченные условия, включая морские районы, гористые регионы и удалённые критические зоны."
    },
    projects: {
      pageTitle: "Наши проекты и кейсы",
      pageSubtitle: "Узнайте, как Petroservice помог клиентам в разных странах снизить риски разведки и открыть продуктивные нефтяные резервуары.",
      completed: "Завершено",
      ongoing: "В процессе",
      statSurveys: "Завершенных съемок",
      statCountries: "Стран",
      statAccuracy: "Точность",
      statSaved: "Экономия клиентов",
      belarus: "Операции в Беларуси",
      belarusDesc: "Операции в нашей родной стране, где мы разработали и усовершенствовали технологию GRS. Множество успешных съемок в различных геологических формациях.",
      belarusShort:"Официальная рекомендация Совета Министров",
      belarusResult1: "Открыто несколько новых нефтяных резервуаров",
      belarusResult2: "Предотвращено бурение в 12+ выявленных сухих ловушках",
      belarusResult3: "Официальная рекомендация Совета Министров",
      belarusHighlight: "Ключевое достижение: Рекомендация правительства для всех национальных разведочных работ",
      kazakhstan: "Разведка в Казахстане",
      kazakhstanDesc: "Крупномасштабные разведочные проекты в богатых нефтью регионах Казахстана, работа с национальными и международными нефтяными компаниями.",
      kazakhstanResult1: "Обследовано более 500 км² разведочной площади",
      kazakhstanResult2: "Выявлено 8 новых перспективных зон резервуаров",
      kazakhstanResult3: "Сэкономлено около $15 млн за счет избежания сухого бурения",
      kazakhstanHighlight: "Ключевое достижение: 100% точность в прогнозировании сухих ловушек по всем обследованным территориям",
      russia: "Россия",
      russiaDesc: "Текущие операции в двух крупных нефтяных регионах России, предоставление услуг предбуровой валидации и открытия новых резервуаров.",
      russiaResult1: "Активные съемки в Краснодарском и Самарском регионах",
      russiaResult2: "Несколько резервуаров сейчас активно инвестируются",
      russiaResult3: "Интеграция с существующими сейсмическими программами",
      russiaHighlight: "Ключевое достижение: Несколько открытий сейчас в фазе добычи",
      syria: "Сирийская Арабская Республика",
      syriaDesc: "Официально квалифицированные операции в Сирии, вклад в развитие и возрождение нефтяной промышленности Ближнего Востока.",
      syriaResult1: "Квалификация Министерства нефти (Резолюция № 6135)",
      syriaResult2: "Поддержка национальных программ нефтеразведки",
      syriaResult3: "Фокус на послеконфликтном развитии ресурсов",
      syriaHighlight: "Ключевое достижение: Первое развертывание технологии GRS на Ближнем Востоке",
      marineTitle: "Морское и шельфовое расширение",
      marineDesc: "Мы успешно проводим эксперименты в морских и шельфовых зонах, распространяя нашу проверенную наземную точность на водную среду разведки.",
      marineStatus: "В настоящее время в экспериментальной фазе",
      ctaTitle: "Начните свой проект с нами",
      ctaDesc: "Присоединяйтесь к нашему растущему списку успешных проектов по всему миру."
    },
    trackRecord: {
      pageTitle: "Доказанные результаты. Доверие государства. Глобальный охват",
      caseStudiesTitle: "Примеры из практики",
      caseStudyKrasnodarTitle: "Успешное применение в морских условиях",
      caseStudyKrasnodarBody: "Успешно протестировано на Курчанской линейной акватории. Результаты подтвердили, что толща воды не влияет на показания оборудования, при этом аномалии чётко фиксируются.",
      caseStudySamaraTitle: "Различение сухих и нефтеносных структур",
      caseStudySamaraBody: "Метод точно дифференцировал нефтеносную структуру «Горьковская» и сухую структуру «Ялтау». Последующее бурение подтвердило, что участок Ялтау оказался непродуктивным, что верифицировало сделанный прогноз.",
      caseStudyKazakhstanTitle: "Картирование сложного резервуара",
      caseStudyKazakhstanBody: "Достигнута высокая сходимость с контурами газоконденсатной залежи на месторождении Чинарей, несмотря на сложную многослойную структуру.",
      clientHistoryTitle: "История Клиентов",
      clientBelorusneft: "Белоруснефть (Беларусь)",
      clientRusOil: "Рус-Ойл (Россия)",
      clientRITEK: "РИТЭК (Россия)",
      clientSyrianPC: "Сирийская Нефтяная Компания (Сирия)",
      clientOther: "Другие Клиенты:",
      clientOtherList: "Печоранефтегаз, Жайкмунай, Адай Петролеум, Лукойл-Калининградморнефть, Роснефть-Краснодарнефтеgaz, Самаранефтегаз.",
      projectYears: "Годы",
      projectCount: "Проекты",
      endorsementLabel: "Государственное подтверждение",
      repBelarus: "Республика Беларусь",
      internationalQualificationLabel: "Международная квалификация",
      successRateLabel: "Коэффициент успеха",
      dryTrapDetectionLabel: "Обнаружение сухих ловушек",
      belarusTitle: "Официальная рекомендация от Президиума Совета Министров Беларуси",
      belarusDesc: "После большого успеха метода GRS в определении скоплений нефти и сухих структур, Президиум Совета Министров Республики Беларусь официально распорядился использовать метод Petroservice во всех разведочных работах на своей территории и посоветовал его расширение за пределы границ.",
      belarusShort: "Официальная рекомендация Совета Министров",
      accuracyTitle: "100% успешность обнаружения сухих ловушек.",
      accuracyDesc: "Статистика Petroservice показывает 100% успешность обнаружения сухих ловушек.. Когда результаты указывают на отсутствие электромагнитных аномалий, это означает сухую ловушку. Это сэкономило огромные ресурсы, оцениваемые в десятки миллионов долларов, за счет предотвращения расходов на неудачные разведочные скважины (например, до 7 миллионов долларов за одну скважину на суше).",
      syriaTitle: "Квалификация для работы на Ближнем Востоке",
      syriaDesc: "Мы официально получили квалификацию от Министерства энергетики Сирии на работу на территории Сирийской Арабской Республики.",
      syriaBadge: "Квалифицировано Министерством энергетики Сирии — Резолюция № 6135",
      syriaQualificationDate: "4 декабря 2019 г.",
      successRatePercent: "100%",
      refineryImageAlt: "Операции в Беларуси",
      drillingImageAlt: "Операции на Ближнем Востоке",
      visionmainTitle: "Наше видение и миссия",
      visionTitle: "Видение",
      missionTitle: "Миссия",
      objectiveTitle: "Цель",
      vision: "Внести существенный вклад в экономическое развитие за счёт эффективного использования местных ресурсов по всему миру.",
      mission: "Возрождение потенциала нефтяной промышленности.",
      objective: "Позволить регионам сосредоточиться на наиболее выгодных инвестициях в нефть и газ, предоставляя высокоточные, экономичные технологии с достаточной гарантией результата."
    },
    about: {
      pageTitle: "О Petroservice",
      intro: "Белорусская нефтесервисная компания, основанная в 2014 году. Мы предоставляем технологии прямого обнаружения, которые снижают риск разведки, время и затраты в международных наземных и шельфовых проектах.",

      overviewTitle: "Обзор компании",
      overviewText: "Основанная в 2014 году, Petroservice разрабатывает и внедряет GRS (Геофизический датчик резервуара) для прямого обнаружения скоплений углеводородов. Наша работа в Беларуси, России, Казахстане, Сирии и других регионах подтвердила метод и принесла ощутимую экономию за счет предотвращения бурения в сухие места.",

      partnerTitle: "Партнёр по успеху",
      partnerText: "KH Group выступает нашим стратегическим партнёром и региональным представителем, обеспечивая доставку проектов, координацию и долгосрочные отношения с клиентами.",

      whyTitle: "Почему Petroservice",
      whyPoint1: "Прямое обнаружение нефтеносных ловушек — не только картирование структуры.",
      whyPoint2: "Высокая точность, снижающая риск разведки и предотвращающая сухие скважины.",
      whyPoint3: "Быстрые обследования и более низкие операционные расходы по сравнению с традиционными методами.",
      whyPoint4: "Применимо как на суше, так и на шельфе с портативным и морским оборудованием.",
      whyPoint5: "Проверенные результаты и официальное признание со стороны государственных органов.",

      goalsTitle: "Цели компании",
      goalsPoint1: "Прямое обнаружение и очерчивание подповерхностных ловушек.",
      goalsPoint2: "Избегать ненужного разведочного бурения и сохранять национальные ресурсы.",
      goalsPoint3: "Поддерживать национальную экономику, сохраняя средства и перенаправляя инвестиции в продуктивные проекты.",
      goalsPoint4: "Минимизировать риск разведки и повышать процент успешных скважин.",

      methodsTitle: "Методология",
      methodsIntro: "Petroservice использует комбинированный подход (электростатика, тепловой анализ и гравитация) в составе GRS для идентификации и проверки залежей.",
      methodElectrostaticTitle: "Электростатическое зондирование",
      methodElectrostaticDesc: "Обнаруживает ионные и электростатические вариации для различения воды и углеводородов и определения границ WOC/OWC.",
      methodThermalTitle: "Тепловой / радиационный анализ",
      methodThermalDesc: "Анализирует термические сигнатуры для различения нефти и газа и выявления накоплений по аномалиям теплового потока.",
      methodGravityTitle: "Гравитационный анализ",
      methodGravityDesc: "Измеряет гравитационные аномалии для выявления подповерхностной структуры и оценки глубины и размеров залежей.",

      implementationTitle: "Внедрение и GRS",
      implementationIntro: "GRS принимает электромагнитные сигналы, обрабатывает их алгоритмами и преобразует результаты в карты и модели глубины для планирования работ.",
      implementationStep1: "Обнаружение ионных полей: Устройство GRS регистрирует электромагнитные или электростатические сигналы от грунта, которые взаимодействуют с этими ионными полями. При прохождении через зоны с высокой ионной активностью, такие как пласты-резервуары, эти сигналы претерпевают изменения частоты, фазы или амплитуды.",
      implementationStep2: "Электростатическое зондирование: Устройство оснащено датчиками, предназначенными для обнаружения электростатических вариаций в подземной среде. Эти датчики фиксируют изменения электрического поля, вызванные наличием ионной активности в подземных резервуарах. Различия в напряжённости ионного поля помогают определить наличие и тип флюида (например, нефть, газ или вода).",
      implementationStep3: "Обработка и интерпретация сигналов: После того как GRS фиксирует сигналы, изменённые ионным полем, данные обрабатываются его внутренними системами. С помощью сложных алгоритмов анализируются вариации электростатического заряда и выявляются области с сильным ионным полем, что указывает на наличие ресурсов. Эти обработанные данные используются для определения местоположения, глубины и границ потенциальных залежей нефти, газа или воды.",
      implementationStep4: "Картирование и визуализация: После интерпретации данных об ионном поле GRS создаёт визуальное представление, например, карты, показывающие зоны концентрации ионного поля. Эти карты направляют разведочные работы, точно указывая области, где с высокой вероятностью содержатся углеводороды или грунтовые  воды. Благодаря использованию выявления ионных полей, устройство GRS повышает точность локализации подземных ресурсов.",

      achievementsTitle: "Достижения",
      achievementsText: "С 2014 года мы провели десятки съёмок, способствующих открытиям резервуаров и предотвращению бурения в многочисленных сухих ловушках — это сэкономило клиентам десятки миллионов долларов.",

      endorsementTitle: "Официальное признание",
      endorsementText: "Метод получил высокую оценку и официальную рекомендацию от государственных органов Беларуси после успешного внедрения.",

      contactTitle: "Региональные офисы и контакты",
      contactIntro: "Мы работаем международно; обращайтесь к региональным командам для запросов и партнёрств.",
      contactBelarus: "220073, РБ, г. Минск, ул. Ольшевского,  д. 24, пом.7а, каб. 7а-1-101.",
      contactBelarusPhone: "+375 44 7444444 / +375 44 4444447 / +375 29 3192377",
      contactBelarusEmail: "info@petroservice.by",
      contactKHTitle: "Представитель — KH Group",
      contactKHText: "Дамаск (Сирия) и Дубай (ОАЭ) — региональные офисы и координация.",

      callToAction: "Присоединяйтесь, чтобы снизить риск разведки и направить инвестиции в продуктивные проекты."
    },
    contact: {
      pageTitle: "Начните безрисковую разведку",
      formName: "Имя",
      formCompany: "Компания",
      formEmail: "Email",
      formCountry: "Страна операций",
      formInquiry: "Тип запроса",
      formMessage: "Сообщение",
      formSubmit: "Отправить запрос",
      inquiryTypes: {
        consultation: "Техническая консультация",
        partnership: "Партнерство",
        general: "Общий запрос"
      },
      hqTitle: "Штаб-квартира",
      hqLocation: "Штаб-квартира Petroservice (Беларусь)",
      hqAddress: "220073, РБ, г. Минск, ул. Ольшевского,  д. 24, пом.7а, каб. 7а-1-101.",
      hqPhone: "+375 44 7444444 / +375 44 4444447 / +375 29 3192377",
      hqEmail: "info@petroservice.by",
      dubaiOfficeTitle: "Офис на Ближнем Востоке (Дубай - ОАЭ)",
      dubaiOfficeAddress: "Дубай - ОАЭ",
      dubaiOfficePhone: "+971 55 106 6128",
      repOfficeTitle: "Представительство (KH Group)",
      repOfficeAddress: "Дамаск, Сирия",
      repOfficePhone: "+963 965 350 010 / +963 965 350 066",
      repOfficeEmail: "info@Kh.sy / info@petro.kh-co.com",
      repOfficeWebsite: "www.kh.sy",
      downloads: "Загрузки",
      downloadProfile: "Скачать профиль компании Petroservice (PDF)",
      downloadEmafTechnicalPaper: "Скачать технический документ GRS (PDF)",
      downloadTechnical: "Скачать технический документ GRS",
      successMessage: "Спасибо! Ваш запрос успешно отправлен.",
      errorMessage: "Что-то пошло не так. Попробуйте снова."
      ,
      selectInquiryPlaceholder: "Выберите тип запроса",
      submitting: "Отправка..."
    },
    footer: {
      copyright: "© 2025 Petroservice. Все права защищены.",
      privacy: "Политика конфиденциальности",
      terms: "Условия использования",
      companyIntro: "Пионер в области прямой детекции углеводородов с 2014 года.",
      quickLinksLabel: "Быстрые ссылки",
      logoAlt: "Petroservice"
    }
    ,
    kh: {
      title: "KH Group: стратегический партнер",
      line1: "KH Group является стратегическим партнером и исполнительным представителем PETRO SERVICE.",
      line2: "История нашего совместного успеха с 2014 года строится на доверии, технической экспертизе и общей приверженности достижению измеримых результатов."
    }
  },
  ar: {
    nav: {
     about: "من نحن",
      home: "الرئيسية",
      technology: "التقنية",
      services: "الخدمات",
     trackRecord: "الوجود العالمي",
      trackRecord: "سجل الإنجازات",
      contact: "اتصل بنا"
    },
    hero: {
      headline: "صفر آبار جافة. استكشاف نفط دقيق.",
      subheadline: "استخدام  (GRS) — الذي يجمع بين الكشف بالرادار والتحليل الحراري والجاذبي والكهرستاتيكي وتحليل المجال الأيوني — لتقليل مخاطر الاستكشاف والتكاليف الرأسمالية الضخمة.",
      trustBadge: "موصى به من مجلس وزراء بيلاروسيا",
      primaryCta: "استكشف تقنيتنا",
      secondaryCta: "تحميل الملف التعريفي"
    },
    promise: {
      title: "ضمان PETROSERVICE",
      accuracy: {
        title: "دقة لا مثيل لها",
        desc: "نسبة نجاح 90% في تحديد بالتجمعات التجارية الإيجابية من الهيدروكربون."
      },
      efficiency: {
        title: "كفاءة قصوى",
        desc: "يلغي الحفر الاستكشافي المكلف في التجمعات الجافة."
      },
      mobility: {
        title: "في البر والبحر",
        desc: "نعمل على اليابسة والبحر مع معدات محمولة وقابلة للعمل في مختلف البيئات."
      }
    },
    challenge: {
      problemTitle: "المشكلة",
      problemDesc: "الطرق التقليدية (مثل السايزمية) لا تحدد بدقة مكامن الهيدروكربون، ولا تؤكد وجود النفط، مما يؤدي إلى حفر آبار قد تكلف 4-100 مليون دولار وقد لا تعطي نتائج.",
      solutionTitle: "حلنا",
      solutionDesc: "نحدد مباشرة التجمعات التجارية من الهيدروكربون باستخدام تقنياتنا الشاملة، مما يضمن أن استثمارك يذهب إلى بئر منتج.",
      solutionMetric: "دقة اكتشاف 90% للتجمعات التجارية الإيجابية"
      ,
      riskAmount: "$4M-$100M",
      riskNote: "لكل بئر\nمعرض للخطر"
    },
    footprint: {
      title: "بصمتنا العالمية",
      desc: "Petroservice شركة بيلاروسية، تأسست عام 2014، تعمل دولياً في أسواق رئيسية تشمل: بيلاروسيا، كازاخستان، روسيا، والجمهورية العربية السورية.",
      stat1: "+9 سنوات نشاط",
      stat2: "+25 مشروع ناجح",
      stat3: "ملايين موفرة"
      ,
      countries: ["بيلاروس","كازاخستان","روسيا","سوريا"]
    },
    cta: {
      title: "تحقيق وفورات كبيرة في تكاليف استكشاف النفط",
      button: "تواصل مع فريقنا"
    },
    technology: {
      pageTitle: "طريقة GRS: الكشف المباشر عن الهيدروكربون",
      intro: "GRS () هو المعيار الجديد في الكشف المباشر. يجمع GRS بين الكشف بالرادار والتحليل الإشعاعي الحراري والجاذبي والكهرستاتيكي وتحليل المجال الأيوني لاكتشاف ودراسة خزانات المياه والنفط والغاز تحت السطح، بدلاً من الاعتماد فقط على البنية الجيولوجية.",
      methodTitle: "أسلوب العمل",
      implementationTitle: "طريقة التنفيذ",
      processTitle: "العملية",
      step1Title: "حقن الإشارة",
      step1Desc: "جهاز إرسال خاص يحقن حقلاً كهرومغناطيسياً متعدد الترددات في المنطقة المستهدفة.",
      step1NewTitle: "الكشف عن الحقول الأيونية:",
      step1NewDesc: "يتلقى جهاز GRS إشارات كهرومغناطيسية أو إلكتروستاتيكية من الأرض، والتي تتفاعل مع هذه الحقول الأيونية. عندما تواجه هذه الإشارات مناطق ذات نشاط أيوني قوي، مثل خزانات السوائل، فإنها تشهد تغيرات في التردد أو الطور أو السعة.",
      step2Title: "التفاعل الشاذ",
      step2Desc: "إذا كان هناك تراكم نفط/غاز، فإنه يولد حقلاً كهرومغناطيسياً ثانوياً فريداً (الشذوذ) يعود إلى السطح.",
      step2NewTitle: "الاستشعار الإلكتروستاتيكي:",
      step2NewDesc: "الجهاز مزود بأجهزة استشعار مصممة للكشف عن التغيرات الإلكتروستاتيكية في البيئة تحت السطحية. تلتقط هذه المستشعرات التغيرات في المجال الكهربائي الناتجة عن وجود نشاط أيوني في الخزانات الجوفية، وتساعد الاختلافات في قوة المجال الأيوني على الإشارة إلى وجود ونوع السائل (مثل النفط أو الغاز أو الماء).",
      step3Title: "جمع البيانات",
      step3Desc: "جهاز الاستقبال RWRC-3 من الجيل الثالث (هوائي 3000 مم) يجمع البيانات العائدة لرسم خريطة حدود ومحتوى الخزان بدقة.",
      step3NewTitle: "معالجة الإشارات وتفسيرها:",
      step3NewDesc: "بمجرد أن يلتقط GRS الإشارات المعدلة بواسطة المجال الأيوني، تتم معالجة البيانات من خلال أنظمته الداخلية. تقوم الخوارزميات المتقدمة بتحليل التغيرات في الشحنة الإلكتروستاتيكية وتحديد المناطق التي يكون فيها المجال الأيوني قويًا، مما يشير إلى وجود موارد. تُستخدم هذه البيانات المعالجة لتحديد الموقع والعمق وحدود خزانات النفط أو الغاز أو الماء المحتملة.",
      step4Title: "رسم خرائط الموارد",
      step4Desc: "يتم تحويل البيانات إلى تصورات ثنائية / ثلاثية الأبعاد ، بما في ذلك الخرائط التي توضح تركيز المجال الأيوني. تحدد هذه الخرائط المناطق بدقة وتحدد العمق الذي يصل إلى 8000 متر تحت الأرض.",
      step4NewTitle: "الخرائط والتصور:",
      step4NewDesc: "بعد تفسير بيانات المجال الأيوني، يقوم GRS بإنشاء تمثيل مرئي، مثل الخرائط، يوضح مكان تركز المجال الأيوني. توجه هذه الخرائط جهود الاستكشاف من خلال تحديد المناطق التي من المحتمل أن تحتوي على الهيدروكربون أو المياه الجوفية. من خلال استخدام الكشف عن المجال الأيوني، يعزز جهاز GRS قدرته على تحديد مواقع الموارد الجوفية بدقة.",
      specsTitle: "التنقل والمواصفات",
      spec1Title: "نظام إلكتروستاتيكي متقدم (تحليل المجال الأيوني)",
      spec1Desc: "يستخدم هذا النظام لتحديد طبيعة السوائل الموجودة في الصخور المسامية عن طريق الكشف عن التغيرات في الحقول الكهروستاتيكية والأيونية تحت السطح ، مما يساعد على تحديد حدود التلامس (WOC أو OWC).",
      spec2Title: "تحليل الإشعاع الحراري",
      spec2Desc: "يستخدم اختلافات الخواص الحرارية بين مكامن الهيدروكربون والصخور المحيطة. من خلال تحليل تغيرات تدفق الحرارة، يتم التمييز بفعالية بين مصايد الغاز والنفط المحتملة.",
      spec3Title: "نظام تباين الجاذبية",
      spec3Desc: "من خلال استخدام تحليل نظام الجاذبية وقياس الشذوذات الجاذبية من أجل تحديد عمق وأبعاد الطبقات الجيولوجية التي تستضيف النفط والغاز.",
      comparisonTitle: "الفرق",
      tableFeature: "الميزة",
      tableSeismic: "السايزمية التقليدية",
      tableEmaf: "Petroservice GRS",
      rowDetects: "يكتشف",
      rowDetectsSeismic: "المصائد الجيولوجية (البنية)",
      rowDetectsEmaf: "محتوى الهيدروكربون (النفط/الغاز)",
      rowRisk: "المخاطر",
      rowRiskSeismic: "عالية (تتطلب حفراً مكلفاً للتحقق)",
      rowRiskEmaf: "ضمان كافٍ بنسبة 90٪ لتراكمات الهيدروكربون التجارية الإيجابية. مخاطرة منخفضة (يتحقق من المحتوى قبل الحفر).",
      rowAccess: "الوصول",
      rowAccessSeismic: "يعتمد على الآلات الثقيلة",
      rowAccessEmaf: "معدات محمولة لجميع التضاريس"
    },
    services: {
      pageTitle: "حلول شاملة لتقليل المخاطر والاكتشاف",
      service1Title: "التحقق قبل الحفر",
      service1Objective: "الهدف: إلغاء الحفر في الهياكل الجافة.",
      service1Desc: "نمسح الحقول المحددة بالطرق التقليدية لتأكيد وجود (أو غياب) الهيدروكربون قبل البدء بأعمال الحفر.",
      service1BenefitTitle: "الفائدة: ",
      service1BenefitDesc: "يزيد من كفاءة رأس المال ويقلل من المخاطر الفنية والتشغيلية مع ضمان 100٪ ضد المصائد الجافة.",
      service2Title: "المسح الاستكشافي",
      service2Objective: "الهدف: الكشف المباشر عن المصائد تحت السطحية التي تحمل الهيدروكربون وتحديد حدودها.",
      service2Desc: "نقوم بعملية الاستكشاف الأولي للمناطق لتحديد مكامن الهيدرو كربون بسرعة وبتكلفة منخفضة.",
      service2BenefitTitle: "الفائدة: ",
      service2BenefitDesc: "يحدد بسرعة المناطق ذات الإمكانات العالية ، مما يقلل من وقت وتكلفة الاستكشاف السايزمي اللاحق ، ويقدم ضمانًا كافيًا بنسبة 90٪ لتراكمات الهيدروكربون التجارية الإيجابية على اليابسة وفي البحر.",
      service3Title: "الدعم الجيولوجي",
      service3Desc: "بياناتنا ، التي تم إنشاؤها بواسطة GRS () ، تتكامل بسلاسة مع النماذج الجيولوجية والبيانات السايزمية. لتوفير ثقة أكبر من خلال التأكيد في ما إذا كانت المصيدة المحددة حاملة للنفط أم قاحلة ، مع نحديد عمق طبقات الاستكشاف إلى 8000 متر.",
      service4Title: "البيئات المتخصصة",
      service4Urban: "التضاريس الحضرية والمعقدة: تتيح لنا معداتنا المحمولة الفريدة مسح البيئات المعقدة والمقيدة ، بما في ذلك مواقع التعدين / الصناعة والمراكز الحضرية المزدحمة والمناطق الجبلية أو الحرجية النائية ذات مخاطر الوصول المنخفضة.",
      service4Marine: "المسوحات البحرية: نجري بنجاح تجارب مسح في المناطق البحرية والبحرية بنفس الدقة الموفرة للتكاليف.",
      service4Combined: "تتيح لنا معداتنا المحمولة الفريدة مسح البيئات المعقدة و المقيدة بما في ذلك  البحار، المناطق الجبلية أو المناطق الحرجة النائية",
    },
    projects: {
      pageTitle: "مشاريعنا ودراسات الحالة",
      pageSubtitle: "اكتشف كيف ساعدت Petroservice العملاء في عدة دول على تقليل مخاطر الاستكشاف واكتشاف خزانات نفط منتجة.",
      completed: "مكتمل",
      ongoing: "جارٍ",
      statSurveys: "مسوحات مكتملة",
      statCountries: "دول",
      statAccuracy: "نسبة الدقة",
      statSaved: "وفورات العملاء",
      belarus: "عمليات بيلاروسيا",
      belarusDesc: "عمليات وطننا حيث طورنا وصقلنا تقنية GRS. مسوحات ناجحة متعددة عبر تشكيلات جيولوجية مختلفة.",
      belarusResult1: "اكتشاف عدة خزانات نفط جديدة",
      belarusResult2: "منع الحفر في 12+ مصيدة جافة محددة",
      belarusResult3: "تأييد رسمي من مجلس الوزراء",
      belarusHighlight: "الإنجاز الرئيسي: توصية حكومية لجميع أعمال الاستكشاف الوطنية",
      kazakhstan: "استكشاف كازاخستان",
      kazakhstanDesc: "مشاريع استكشاف واسعة النطاق في المناطق الغنية بالنفط في كازاخستان، العمل مع شركات النفط الوطنية والدولية.",
      kazakhstanResult1: "مسح أكثر من 500 كم² من منطقة الاستكشاف",
      kazakhstanResult2: "تحديد 8 مناطق خزان محتملة جديدة",
      kazakhstanResult3: "توفير ما يقدر بـ 15 مليون دولار في تجنب الحفر الجاف",
      kazakhstanHighlight: "الإنجاز الرئيسي: دقة 100% في تحديد بالمصائد الجافة عبر جميع المناطق المسوحة",
      russia: "روسيا",
      russiaDesc: "عمليات مستمرة في منطقتين نفطيتين رئيسيتين في روسيا، تقديم خدمات التحقق قبل الحفر واكتشاف خزانات جديدة.",
      russiaResult1: "مسوحات نشطة في مناطق  وسامارا",
      russiaResult2: "عدة خزانات الآن تحت الاستثمار النشط",
      russiaResult3: "التكامل مع برامج زلزالية قائمة",
      russiaHighlight: "الإنجاز الرئيسي: عدة اكتشافات الآن في مرحلة الإنتاج",
      syria: "الجمهورية العربية السورية",
      syriaDesc: "عمليات مؤهلة رسمياً في سوريا، المساهمة في تطوير ونهضة صناعة النفط في الشرق الأوسط.",
      syriaResult1: "مؤهل من وزارة النفط (القرار رقم 6135)",
      syriaResult2: "دعم برامج استكشاف النفط الوطنية",
      syriaResult3: "التركيز على تنمية الموارد بعد الصراع",
      syriaHighlight: "الإنجاز الرئيسي: أول نشر لتقنية GRS في الشرق الأوسط",
      marineTitle: "التوسع البحري والبحري",
      marineDesc: "نجري بنجاح تجارب مسح في المناطق البحرية والبحرية، موسعين دقتنا المثبتة على اليابسة إلى بيئات الاستكشاف المائية.",
      marineStatus: "حالياً في المرحلة التجريبية",
      ctaTitle: "ابدأ مشروعك معنا",
      ctaDesc: "انضم إلى قائمتنا المتنامية من المشاريع الناجحة حول العالم."
    },
    trackRecord: {
      pageTitle: "نتائج مثبتة. ثقة حكومية. انتشار عالمي.",
      caseStudiesTitle: "دراسات الحالة",
      caseStudyKrasnodarTitle: "نجاح البيئة البحرية",
      caseStudyKrasnodarBody: "تم اختباره بنجاح في منطقة مياه كورتشانسكي ليمان. أكدت النتائج أن سمك الطبقة المائية لا يؤثر على قراءات الأجهزة.",
      caseStudySamaraTitle: "التفريق بين الجاف والحامل للنفط",
      caseStudySamaraBody: "تميز بدقة بين هيكل 'جوركي' الحامل للنفط وهيكل 'يالتاو' الجاف. أكد الحفر اللاحق أن موقع 'يالتاو' كان جافًا، مما يؤكد عملية الاستكشاف.",
      caseStudyKazakhstanTitle: "رسم خرائط الخزانات المعقدة",
      caseStudyKazakhstanBody: "تم تحقيق تقارب عالٍ مع منحنيات تراكم مكثفات الغاز في حقل شينايف، على الرغم من الجيولوجيا المعقدة متعددة الطبقات.",
      clientHistoryTitle: "تاريخ العملاء",
      clientBelorusneft: "بيلاروس نفط (بيلاروسيا)",
      clientRusOil: "روس-أويل (روسيا)",
      clientRITEK: "ريتيك (روسيا)",
      clientSyrianPC: "الشركة السورية للنفط (سوريا)",
      clientOther: "عملاء آخرون:",
      clientOtherList: "بيتشورانفتيغاز، جايك موني، أداي بتروليوم، لوك أويل-كالينينغراد مورنفت، روسنفت- سمارانفتيغاز.",
      projectYears: "السنوات",
      projectCount: "المشاريع",
      endorsementLabel: "تأييد حكومي",
      repBelarus: "جمهورية بيلاروس",
      internationalQualificationLabel: "مؤهل دولياً",
      successRateLabel: "معدل النجاح",
      dryTrapDetectionLabel: "تحديد المصائد الجافة",
      belarusTitle: "توصية رسمية من رئاسة مجلس وزراء بيلاروسيا",
      belarusDesc: "بعد النجاح الكبير لطريقة GRS في تحديد تجمعات النفط والهياكل الجافة ، وجهت رئاسة مجلس وزراء جمهورية بيلاروسيا رسميًا باستخدام طريقة Petroservice في جميع أعمال الاستكشاف داخل أراضيها ونصحت بتوسيعها خارج الحدود.",
      belarusShort: "توصية رسمية من رئاسة مجلس وزراء بيلاروسيا",
      accuracyTitle: "نسبة نجاح 100٪ في تحديد المصائد الجافة",
      accuracyDesc: "تظهر إحصائيات Petroservice نسبة نجاح 100٪ في توقع الآبار الجافة. وقد وفر هذا موارد هائلة، تقدر بعشرات الملايين من الدولارات، من خلال منع الإنفاق على آبار استكشافية غير ناجحة (على سبيل المثال، ما يصل إلى 7 ملايين دولار لكل بئر على اليابسة).",
      syriaTitle: "مؤهلون للعمل في الشرق الأوسط",
      syriaDesc: "تم تأهيلنا رسمياً من وزارة الطاقة السورية للعمل داخل أراضي الجمهورية العربية السورية",
      syriaBadge: "مؤهل من وزارة الطاقة - سوريا - القرار رقم 6135",
      syriaQualificationDate: "4 ديسمبر 2019",
      successRatePercent: "100%",
      refineryImageAlt: "عمليات بيلاروسيا",
      drillingImageAlt: "عمليات الشرق الأوسط",
      visionmainTitle: "رؤيتنا ورسالتنا",
      visionTitle: "الرؤية",
      missionTitle: "المهمة",
      objectiveTitle: "الهدف",
      vision: "المساهمة الحيوية في التنمية الاقتصادية من خلال الاستخدام الكافي للموارد المحلية على مستوى العالم.",
      mission: "نهضة قدرات صناعة النفط.",
      objective: "تمكين الأقاليم من التركيز على أفضل الاستثمارات في النفط والغاز من خلال توفير دراية عالية الدقة ومنخفضة التكلفة مع ضمان كافٍ."
    },
    about: {
      pageTitle: "حول Petroservice",
      intro: "شركة خدمات نفطية بيلاروسية تأسست عام 2014. نقدم تقنيات الكشف المباشر التي تقلل من مخاطر ووقت وتكاليف الاستكشاف في مشاريع برية وبحرية دولية.",

      overviewTitle: "لمحة عن الشركة",
      overviewText: "تأسست في عام 2014، تطور Petroservice وتطبق GRS () للكشف المباشر عن تراكمات هيدروكربون. أكدت أعمالنا في بيلاروسيا وروسيا وكازاخستان وسوريا وغيرها فعالية الطريقة وحققت وفورات ملموسة من خلال تجنب الحفر في المصائد الجافة.",

      partnerTitle: "شريك النجاح",
      partnerText: "KH Group هو شريكنا الاستراتيجي والممثل المحلي، مما يسهل تنفيذ المشاريع والتنسيق الإقليمي وبناء علاقات طويلة الأمد مع العملاء.",

      whyTitle: "لماذا Petroservice",
      whyPoint1: "الكشف المباشر عن المصائد الحاملة للنفط — وليس مجرد رسم بنية جيولوجية.",
      whyPoint2: "دقة عالية تقلل من مخاطر الاستكشاف وتمنع الآبار الجافة.",
      whyPoint3: "مسوحات أسرع وتكاليف تشغيل أقل مقارنة بالطرق التقليدية.",
      whyPoint4: "قابلة للتطبيق على اليابسة والبحر مع معدات محمولة وقابلة للعمل في البحر.",
      whyPoint5: "نتائج مثبتة واعتراف رسمي من الجهات الوطنية.",

      goalsTitle: "أهداف الشركة",
      goalsPoint1: "الكشف المباشر وتحديد حدود المصائد تحت السطحية.",
      goalsPoint2: "تجنب الحفر الاستكشافي غير الضروري والحفاظ على الموارد الوطنية.",
      goalsPoint3: "دعم الاقتصاد الوطني بتوفير الأموال وإعادة توجيه الاستثمارات لمشروعات منتجة.",
      goalsPoint4: "تقليل مخاطرة الاستكشاف وزيادة معدل نجاح الآبار.",

      methodsTitle: "منهجيتنا",
      methodsIntro: "تستخدم Petroservice نهجًا مركبًا (كهربائي، حراري، وجاذبي) في نظام GRS لتحديد والتحقق من التراكمات.",
      methodElectrostaticTitle: "الاستشعار الكهروستاتيكي",
      methodElectrostaticDesc: "يكتشف التغيرات الأيونية والكهروستاتيكية لتمييز الماء عن الهيدروكربون وتحديد حدود WOC/OWC.",
      methodThermalTitle: "التحليل الحراري / الإشعاعي",
      methodThermalDesc: "يحلل التوقيعات الحرارية للمساعدة في التمييز بين النفط والغاز وكشف التجمعات عبر شذوذ تدفق الحرارة.",
      methodGravityTitle: "التحليل الجاذبي",
      methodGravityDesc: "يقيس الشذوذات الجاذبية للكشف عن البنية تحت السطحية وتقدير العمق وأبعاد الطبقات الحاملة.",

      implementationTitle: "التنفيذ و GRS",
      implementationIntro: "يستقبل GRS إشارات كهرومغناطيسية، يعالجها بخوارزميات متقدمة ويحول النتائج إلى خرائط ونماذج عمق لتخطيط الأعمال.",
      implementationStep1: "كشف الحقول الأيونية: الإشارات تتغير في التردد أو الطور أو السعة عند التفاعل.",
      implementationStep2: "الاستشعار الكهروستاتيكي: تلتقط المستشعرات تغيرات المجال الكهربائي التي تشير إلى نوع السائل (نفط، غاز، ماء).",
      implementationStep3: "معالجة الإشارة: تحدد البيانات المعالجة مناطق الموارد المحتملة وتقدر العمق والحدود.",
      implementationStep4: "الرسم: توجه الخرائط والنماذج البصرية قرارات الحفر (حتى عمق 8000 م).",

      achievementsTitle: "الإنجازات",
      achievementsText: "منذ عام 2014 أجرينا عشرات المسوحات، وأسهمت في اكتشاف خزانات جديدة ومنعت الحفر في العديد من المصائد الجافة - موفرة لعملائنا عشرات الملايين من الدولارات.",

      endorsementTitle: "الاعتراف الرسمي",
      endorsementText: "نال الأسلوب تقديرًا عاليًا وتوصية رسمية من السلطات الوطنية في بيلاروس بعد عمليات ناجحة.",

      contactTitle: "المكاتب الإقليمية وبيانات الاتصال",
      contactIntro: "نعمل دوليًا؛ تواصل مع فرقنا الإقليمية لطلبات المشاريع والشراكات.",
      contactBelarus: "220073، جمهورية بيلاروسيا، مينسك، شارع أولشيفسكوغو، المبنى 24، الغرفة 7أ، المكتب 7أ-1-101.",
      contactBelarusPhone: "+375 44 7444444 / +375 44 4444447 / +375 29 3192377",
      contactBelarusEmail: "info@petroservice.by",
      contactKHTitle: "الممثل — KH Group",
      contactKHText: "دمشق (سوريا) ودبي (الإمارات) — مكاتب إقليمية وتنسيق.",

      callToAction: "انضم إلينا لتقليل مخاطر الاستكشاف وتوجيه الاستثمارات نحو مشاريع منتجة."
    },
    contact: {
      pageTitle: "ابدأ استكشافك الخالي من المخاطر",
      formName: "الاسم",
      formCompany: "الشركة",
      formEmail: "البريد الإلكتروني",
      formCountry: "بلد العمليات",
      formInquiry: "نوع الاستفسار",
      formMessage: "الرسالة",
      formSubmit: "إرسال الاستفسار",
      inquiryTypes: {
        consultation: "استشارة تقنية",
        partnership: "شراكة",
        general: "استفسار عام"
      },
      hqTitle: "المقر الرئيسي",
      hqLocation: "مقر Petroservice (بيلاروسيا)",
      hqAddress: "220073، جمهورية بيلاروسيا، مينسك، شارع أولشيفسكوغو، المبنى 24، الغرفة 7أ، المكتب 7أ-1-101.",
      hqPhone: "+375 44 7444444 / +375 44 4444447 / +375 29 3192377",
      hqEmail: "info@petroservice.by",
      dubaiOfficeTitle: "مكتب الشرق الأوسط (دبي - الإمارات العربية المتحدة)",
      dubaiOfficeAddress: "دبي - الإمارات العربية المتحدة",
      dubaiOfficePhone: "+971 55 106 6128",
      repOfficeTitle: "مكتب تمثيلي (مجموعة KH)",
      repOfficeAddress: "دمشق، سوريا",
      repOfficePhone: "+963 965 350 010 / +963 965 350 066",
      repOfficeEmail: "info@Kh.sy / info@petro.kh-co.com",
      repOfficeWebsite: "www.kh.sy",
      downloads: "التحميلات",
      downloadProfile: "تحميل ملف شركة Petroservice الكامل (PDF)",
      downloadEmafTechnicalPaper: "تنزيل الورقة الفنية لـ GRS (PDF)",
      downloadTechnical: "تنزيل الورقة الفنية لـ GRS",
      successMessage: "شكراً! تم إرسال استفسارك بنجاح.",
      errorMessage: "حدث خطأ ما. يرجى المحاولة مرة أخرى.",
      selectInquiryPlaceholder: "اختر نوع الاستفسار",
      submitting: "جاري الإرسال..."
    },
    footer: {
      copyright: "© 2025 Petroservice. جميع الحقوق محفوظة.",
      privacy: "سياسة الخصوصية",
      terms: "شروط الخدمة"
      ,
      companyIntro: "روّاد تقنيات الكشف المباشر عن الهيدروكربون منذ عام 2014.",
      quickLinksLabel: "روابط سريعة",
      logoAlt: "Petroservice"
    }
    ,
    kh: {
      title: "KH Group: الشريك الاستراتيجي",
      line1: "KH Group هو الشريك الاستراتيجي والممثل التنفيذي لشركة PETRO SERVICE.",
      line2: "قصة نجاح مشتركة منذ 2014 — مبنية على الثقة والخبرة التقنية والالتزام المشترك بتحقيق نتائج ملموسة."
    }
  }
};

export default translations;